import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FilterConfig } from "./filter-config";

@Component({
  selector: 'ngx-side-filter',
  templateUrl: './side-filter.component.html',
  styleUrls: ['./side-filter.component.scss']
})
export class SideFilterComponent {
  @Input() filters: FilterConfig[] = [];
  @Output() filtersChanged = new EventEmitter<any>();
  @Output() searched = new EventEmitter<any>();
  @Output() closed = new EventEmitter<any>();

  public selectedFilters: any = {};

  constructor() {}

  clearDateRange(key: string) {
    this.onFilterChange(key, null);
  }

  onFilterChange(key: string, value: any) {
    this.selectedFilters[key] = value;
    this.filtersChanged.emit(this.selectedFilters);
  }

  onCheckboxChange(key: string, value: any, checked: boolean) {
    if (!Array.isArray(this.selectedFilters[key])) {
      this.selectedFilters[key] = [];
    }

    if (checked) {
      this.selectedFilters[key].push(value);
    } else {
      this.selectedFilters[key] = this.selectedFilters[key].filter((v: any) => v !== value);
    }

    this.filtersChanged.emit(this.selectedFilters);
  }

  onSearch() {
    this.searched.emit();
  }

  onClose() {
    this.closed.emit();
  }

  onRefresh() {
    const multiSelectFilters = this.filters.filter(f => f.type === "multi-select");
    this.selectedFilters = {};
    if (multiSelectFilters.length >= 1) {
      multiSelectFilters.forEach(multiFilter => this.selectedFilters[multiFilter.key] = []);
    }
  }

  onPutFilter(key: string, value: any) {
    this.selectedFilters[key] = value;
  }
}